module.exports = __webpack_public_path__ + "static/media/arrow-bar-left.15b3f0c6.svg";